var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockContainer',{staticClass:"ModuleFaces",attrs:{"type":"Module","label":"moduleFaces"}},[_c('ButtonPlain',{attrs:{"label":"Clear names userstate"},on:{"click":function($event){return _vm.clearNamesUserstate()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }